import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import SophisticatedTooltipContent from '../SophisticatedTooltipContent';
import s from './SophisticatedTooltipBase.scss';
/**
 * Provides the base or our implementation of the SophisticatedTooltip.
 *
 * This is separated out to make it easier to manage differing opening/closing logic between FTUEs and normal tooltips.
 */ const SophisticatedTooltipBase = (_param)=>{
    var { width, postfix, prefix, size, description, forceTheme, hasCloseButton, onClose, onReferenceClick, onReferenceMouseEnter, onReferenceMouseLeave, children, className, contentClassName } = _param, rest = _object_without_properties(_param, [
        "width",
        "postfix",
        "prefix",
        "size",
        "description",
        "forceTheme",
        "hasCloseButton",
        "onClose",
        "onReferenceClick",
        "onReferenceMouseEnter",
        "onReferenceMouseLeave",
        "children",
        "className",
        "contentClassName"
    ]);
    const heading = rest.heading;
    const ariaLabel = rest['aria-label'];
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, _object_spread({
        className: c(s['root'], className),
        onReferenceClick: onReferenceClick,
        onReferenceMouseEnter: onReferenceMouseEnter,
        onReferenceMouseLeave: onReferenceMouseLeave,
        renderPopover: (popperProps)=>/*#__PURE__*/ React.createElement(SophisticatedTooltipContent, _object_spread({
                width: width,
                heading: heading,
                "aria-label": ariaLabel,
                description: description,
                prefix: prefix,
                postfix: postfix,
                size: size,
                contentClassName: contentClassName,
                hasCloseButton: hasCloseButton,
                forceTheme: forceTheme,
                onMouseEnter: onReferenceMouseEnter,
                onMouseLeave: onReferenceMouseLeave,
                onClose: onClose
            }, popperProps))
    }, rest), children);
};
SophisticatedTooltipBase.displayName = 'SophisticatedTooltipBase';
export default SophisticatedTooltipBase;
